module.exports = __webpack_public_path__ + "img/moon-clouds-thunder-01.ffc7e350.png";